import React, { useEffect, useState } from "react";
import { MoreVertical } from "lucide-react";
import { LuSearch } from "react-icons/lu";
import "../../components/DashboardModule/MyQuotations.css";
import BuyerQuotationDashboard from "./BuyerQuotationDashboard";
import { getBuyerQuotationEnquiries } from "../../API/Api";

const QuotationReceived = () => {
    const [enquiries, setEnquiries] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [showPreview, setShowPreview] = useState(false);
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);

    useEffect(() => {
        const fetchEnquiries = async () => {
            try {
                const data = await getBuyerQuotationEnquiries();
                setEnquiries(data?.data || []);
            } catch (error) {
                console.error("Error fetching enquiries:", error);
            }
        };

        fetchEnquiries();
    }, []);

    const filteredEnquiries = enquiries.filter((enquiry) => {
        const searchLower = searchTerm.toLowerCase();
        return (
            enquiry.order_id?.toLowerCase().includes(searchLower) ||
            (enquiry.enquiry_items?.some(item =>
                item.product_name?.toLowerCase().includes(searchLower)
            )) ||
            (enquiry.brands?.some(brand =>
                brand.name?.toLowerCase().includes(searchLower)
            ))
        );
    });

    const handlePreviewClick = (enquiry) => {
        console.log("enquiry=============", enquiry);
        setSelectedEnquiry(enquiry);
        setShowPreview(true);
    };

    return showPreview ? (
        <BuyerQuotationDashboard enquiryId={selectedEnquiry} onBack={() => setShowPreview(false)} />
    ) : (
        <div className="quo-container font-poppins">
            <div className="quo-header">
                <h2 className="quo-title">Quotation Received</h2>
                <div className="quo-actions">
                    <div className="quo-search-container">
                        <LuSearch className="quo-search-icon" />
                        <input
                            type="text"
                            placeholder="Search quotations"
                            className="quo-search font-poppins"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <table className="quo-table">
                <thead>
                    <tr>
                        <th>Enquiry No.</th>
                        <th>Suppliers</th>
                        <th></th>
                        <th>Date</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredEnquiries.map((enquiry) => (
                        <tr key={enquiry.enquiry_id}>
                            <td>
                                <div className="enquiry-info">
                                    <div className="enquiry-name">
                                    </div>
                                    <div className="order-id">
                                        {enquiry.order_id}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="suppliers-container">
                                    {enquiry.brands?.length > 0 ? (
                                        enquiry.brands.map((brand) => (
                                            <div key={brand.id} className="supplier-name">
                                                {brand.name}
                                            </div>
                                        ))
                                    ) : (
                                        <div className="supplier-name">....</div>
                                    )}
                                </div>
                            </td>
                            <td>{enquiry.status === "Pending" ? "Waiting for Quotation" : enquiry.status}</td>
                            <td>
                                {enquiry.created_at ? new Date(enquiry.created_at).toLocaleDateString() : "...."}
                            </td>
                            <td>
                                <div className="quo-action-menu">
                                    <MoreVertical />
                                    <div className="quo-dropdown">
                                        <button
                                            className="text-quo font-poppins"
                                            onClick={() => handlePreviewClick(enquiry.enquiry_id)}
                                        >
                                            Preview
                                        </button>
                                        {/* <button className="text-quo font-poppins">Add comment</button>
                                        <button className="text-quo font-poppins">Download</button>
                                        <button className="text-quo font-poppins">Cancel</button> */}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default QuotationReceived;